import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@beautyburst/tokens/css';
import '@beautyburst/ui/styles';
import './styles.css';
import { BRAND_LOGO } from '@beautyburst/ui';
import { BrowserAdminApp } from './browser-app.tsx';
import { adminAsset } from './base-path.ts';

const root = document.getElementById('root');
if (root === null) throw new Error('Administrator portal root is missing.');
const favicon = document.querySelector<HTMLLinkElement>('#beauty-burst-favicon');
if (favicon !== null) favicon.href = adminAsset(BRAND_LOGO.mark);
createRoot(root).render(
  <StrictMode>
    <BrowserAdminApp />
  </StrictMode>,
);
